export const baseUrls = {
  messageHub: process.env.REACT_APP_MESSAGE_HUB || 'https://localhost: 44390',
  supportApi: process.env.REACT_APP_SUPPORT_API || 'https://localhost:44395',
}
